var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecordActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0199 7.33026C20.3935 7.15145 20.8413 7.30938 21.0201 7.68301C21.6637 9.0278 22 10.5021 22 12.0001C22 14.6522 20.9464 17.1958 19.0711 19.0711C16.0485 22.0937 11.476 22.8383 7.68199 21.0226C7.30836 20.8438 7.15043 20.3959 7.32924 20.0223C7.50806 19.6487 7.9559 19.4907 8.32953 19.6695C11.5541 21.2128 15.4411 20.5798 18.0104 18.0105C19.6045 16.4164 20.5 14.2544 20.5 12.0001C20.5 10.7268 20.2142 9.47367 19.6671 8.33055C19.4883 7.95692 19.6462 7.50908 20.0199 7.33026Z",
    fill: "#3BC2C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0711 5.98959C19.364 5.6967 19.364 5.22183 19.0711 4.92893C15.1658 1.02369 8.83418 1.02369 4.92893 4.92893C1.02369 8.83418 1.02369 15.1658 4.92893 19.0711C5.22183 19.364 5.6967 19.364 5.98959 19.0711C6.28249 18.7782 6.28249 18.3033 5.98959 18.0104C2.67014 14.691 2.67014 9.30905 5.98959 5.98959C9.30905 2.67014 14.691 2.67014 18.0104 5.98959C18.3033 6.28249 18.7782 6.28249 19.0711 5.98959ZM12.7432 6.14823C12.6935 5.78215 12.3797 5.5 12 5.5C11.5858 5.5 11.25 5.83579 11.25 6.25V12.6136L11.2573 12.7182C11.2816 12.8905 11.3652 13.0501 11.4955 13.1686L15.4955 16.805L15.583 16.8735C15.8866 17.0771 16.3017 17.0331 16.555 16.7545L16.6235 16.667C16.8271 16.3634 16.7831 15.9483 16.5045 15.695L12.75 12.282V6.25L12.7432 6.14823Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordActive);
export default __webpack_public_path__ + "static/media/recordActive.5393ba10c507fa75b2f808b7dc802801.svg";
export { ForwardRef as ReactComponent };